//  #####  ##    ##  #####     ###    ##     ##  ####
//  ##      ##  ##   ##  ##   ## ##   ####   ##  ##  ##
//  #####    ####    #####   ##   ##  ##  ## ##  ##  ##
//  ##      ##  ##   ##      #######  ##    ###  ##  ##
//  #####  ##    ##  ##      ##   ##  ##     ##  ####

// 要素を特定の高さで省略、クリックで開閉

/*

data-border-pc="120" data-border-sp="120" でデバイスごとに高さ上限を設定 -1でそのデバイスは全開

<div class="js-expand--<?php echo $reviewID; ?> activeToggle expandBox">

    コンテンツ

      <button type="button" class="js-expand expandBox__more flex vcenter hcenter" data-expand-target="<?php echo $reviewID; ?>" data-expand-pc="120,120" data-expand-sp="120,120">
          <div class="is-false activeToggle__off flex vcenter hcenter">
              もっと見る
              <i class="expandBox__icon icon-expand-open"></i>
          </div>
          <div class="is-false activeToggle__on flex vcenter hcenter">
              閉じる
              <i class="expandBox__icon icon-expand-close"></i>
          </div>
      </button>
</div>


$moreHeight: 3rem;
.expandBox {
  position: relative;
  overflow: hidden;
  &::before {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: $moreHeight + 2rem;
    background-image: linear-gradient(180deg, rgba(#fff, 0), #fff 50%, #fff);
    pointer-events: none;
    content: "";
  }
  &.full {
    max-height: none !important;
    &.active {
      padding-bottom: $moreHeight;
    }
  }
  &.active {
    padding-bottom: $moreHeight + 1rem;
    max-height: none !important;
    &::before {
      display: none;
    }
  }
  &__more {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: $moreHeight;
    font-size: 1.4rem;
    color: var(--link-color);
  }
  &__icon {
    margin: 0 0 0 0.5rem;
  }
}

*/

window.expand = function () {
  const expand = document.querySelectorAll('.js-expand:not(.setup)')
  if (!expand[0]) {
    return
  }
  // デバイス幅に応じて取得するパラメータを変更
  const borerName = window.matchMedia('(min-width:769px)').matches ? 'expandPc' : 'expandSp'

  // 高さをチェックし、想定より低い場合は開閉機構を省略する
  for (const expandBtn of expand) {
    const target = expandBtn.dataset.expandTarget
    expandBtn.classList.add('setup')
    // 表示デバイスに対する基準の高さを取得
    const data = expandBtn.dataset[borerName].split(',') // ,区切りで配列に変換

    const border = parseInt(data[0], 10) // 圧縮判定高さ
    const expand = data[1] ? parseInt(data[1], 10) : border // 圧縮高さ

    const expandTarget = document.getElementsByClassName('js-expand--' + target)
    for (const iterator of expandTarget) {
      if (border === -1 || iterator.offsetHeight < border) {
        console.log('off')

        // 判定高さより低いか、-1指定なら無効化
        iterator.classList.add('active')
        iterator.classList.add('full')
        expandBtn.style.display = 'none'
      } else {
        console.log('on')
        // 高さ制限をかける
        iterator.style.maxHeight = expand + 'px'
        expandBtn.style.display = ''
      }
    }
  }
}
window.expand() // クリックでテキストを開閉

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-expand')) {
    return
  }
  const target = e.target.dataset.expandTarget

  const expandTarget = document.getElementsByClassName('js-expand--' + target)

  for (const iterator of expandTarget) {
    iterator.classList.toggle('active')
  }
})
